<template>
  <div class="wrapper">
    <!-- data-original="item.img" -->
    <div id="images">
      <img class="img-item" v-for="item in detail" :key="'s'+item.id" :src="item.img" alt>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "./../../common/minix.less";
.wrapper {
  width: 100%;
  .section2-img {
    width: 100%;
  }
  .swiper-slide {
    padding-bottom: 30 / @rem;
  }
}
#images {
  .img-item {
    width: 100%;
    display: block;
    box-shadow: 0 0 25px rgba(195, 205, 224, 0.7);
    margin-bottom: 30 / @rem;
  }
}
</style>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import "../../../static/css/swiper-4.1.0.min.css";
import Swiper from "../../../static/js/swiper-4.1.0.min.js";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detail: [],
      viewjsState: ""
    };
  },
  computed: {
    ...mapGetters(["indexSlide"])
  },
  methods: {
    ...mapActions(["firstTitle", "secondTitle"]),
    scaleView() {
      this.viewjsState = new Viewer(document.getElementById("images"), {
        button: true,
        title: false, //是否显示当前图片的标题
        navbar: false, //是否显示导航缩略图
        tooltip: false, //显示缩放百分比
        toolbar: {
          //   prev: {
          //     size: "large"
          //   },
          //   zoomIn: {
          //     size: "large"
          //   },
          //   zoomOut: {
          //     size: "large"
          //   },
          //   next: {
          //     size: "large"
          //   }
        },
        // url: "data-original"
      });
    },
    getDetail() {
      let _this = this;
      userApi
        .getjournalDetail({ journal_id: _this.$route.query.id })
        .then(res => {
          _this.detail = res.data;
          _this.$nextTick().then(function() {
            if (_this.viewjsState) {
              _this.viewjsState.destroy();
            }
            setTimeout(() => {
              _this.scaleView();
            });
          });
        });
    }
  },
  mounted() {
    this.secondTitle(
      this.$route.query.year + "年第" + this.$route.query.num + "期"
    );
    this.getDetail();
  },
  destroyed () {
    this.viewjsState.destroy();
  },
  watch: {
    $route() {
      this.secondTitle(
        this.$route.query.year + "年第" + this.$route.query.num + "期"
      );
      this.getDetail();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Journal/detail.vue